(function(){
  const replacements = [
    [/\b(?:pan oxyl|panoxy|panox|panocyl|panoply)\b/gi, 'PanOxyl'],
    [/\b(?:adaplene|adapalane)\b/gi, 'adapalene'],
    [/\b(?:differen|differing)\b/gi, 'Differin'],
    [/\b(?:benzol|benzoulyl) peroxide\b/gi, 'benzoyl peroxide'],
    [/\b(?:salycilic|salycylic) acid\b/gi, 'salicylic acid'],
    [/\bsulphur\b/gi, 'sulfur'],
    [/\bsimeticone\b/gi, 'simethicone'],
    [/\b(?:tsal|t sal)\b/gi, 'T/Sal'],
    [/\bcera ve\b/gi, 'CeraVe'],
    [/\bdelacruz\b/gi, 'De La Cruz'],
    [/\bderma harmony\b/gi, 'DermaHarmony'],
    [/\bacne free\b/gi, 'AcneFree']
  ];
  window.usaSearchTerm = function(value){
    if (/\b(?:id|title|vendor|tag|product_type):/i.test(value)) return value;
    return replacements.reduce(function(term,pair){return term.replace(pair[0],pair[1])},value).trim();
  };
  // These names must match the product title, not incidental ingredients in descriptions.
  window.usaPreciseSearch = function(value){
    const term=window.usaSearchTerm(value).trim();
    if(/^(?:neutrogena\s+)?t[\s/-]?sal(?:\s+shampoo)?$/i.test(term))return {label:'T/Sal',query:'title:"T/Sal"'};
    if(/^simethicone$/i.test(term))return {label:'simethicone',query:'title:simethicone'};
    return null;
  };
  function searchDestination(url,value){
    const precise=window.usaPreciseSearch(value);
    if(!precise)return null;
    url.pathname='/search';url.searchParams.set('q',precise.query);
    url.searchParams.set('type','product');url.searchParams.set('options[unavailable_products]','last');
    url.searchParams.delete('page');return url;
  }
  document.addEventListener('submit',function(event){
    const form=event.target;if(!(form instanceof HTMLFormElement))return;
    const url=new URL(form.action,location.href);if(!/\/search$/.test(url.pathname))return;
    const input=form.querySelector('[name="q"]');if(!input)return;
    input.value=window.usaSearchTerm(input.value);
    const destination=searchDestination(url,input.value);
    if(destination){event.preventDefault();event.stopImmediatePropagation();location.assign(destination.href);}
  },true);
  const current=new URL(location.href);
  if(/\/search$/.test(current.pathname)&&current.searchParams.has('q')){
    const original=current.searchParams.get('q'),normal=window.usaSearchTerm(original);
    const destination=searchDestination(new URL(current),normal);
    if(destination){location.replace(destination.href);}
    else if(normal!==original){current.searchParams.set('q',normal);current.searchParams.delete('page');location.replace(current.href);}
  }
  // The search app caches its own copy of the results template.
  function refineAppSearch(){
    // The app can restore the raw URL query after the theme has rendered friendly labels.
    document.querySelectorAll('input[type="search"][name="q"]').forEach(function(input){
      const labels={'title:"T/Sal"':'T/Sal','title:simethicone':'simethicone'};
      const label=labels[input.value];if(label){input.value=label;input.setAttribute('value',label);}
    });
    if(!/\/a\/search$/.test(location.pathname))return;
    document.querySelectorAll('div#product-grid').forEach(function(wrapper){if(wrapper.querySelector('ul#product-grid'))wrapper.id='search-results-wrapper'});
    const form=document.querySelector('#MainContent form.search[action="/a/search"]');if(!form)return;
    const q=(new URL(location.href).searchParams.get('q')||'').toLowerCase();
    const routes=[[/acne wash|spot wash|acne cleanser/,'cleansers','Browse acne washes and cleansers'],[/spot cream|spot treatment|acne cream|acne gel/,'acne-care','Browse acne care'],[/sensitive skin/,'sensitive-skin','Shop sensitive skin'],[/dark spot/,'dark-spots','Shop dark spots'],[/dry skin/,'dry-skin','Shop dry skin'],[/benzoyl/,'benzoyl-peroxide','Shop benzoyl peroxide'],[/adapalene/,'adapalene-gel','Shop adapalene'],[/salicylic/,'salicylic-acid','Shop salicylic acid'],[/sulfur|sulphur/,'sulfur-skin-care','Shop sulphur']];
    const match=routes.find(function(route){return route[0].test(q)});
    let box=document.querySelector('[data-usa-search-route]');
    if(!match){if(box)box.remove();return;}
    if(!box){box=document.createElement('div');box.className='usa-search-route';box.dataset.usaSearchRoute='true';const aside=document.createElement('aside');aside.className='usa-guide-links';aside.setAttribute('aria-label','Related collection');aside.append(document.createElement('a'));box.append(aside);form.after(box);}
    const link=box.querySelector('a'),href='/collections/'+match[1];if(link.getAttribute('href')!==href)link.setAttribute('href',href);if(link.textContent!==match[2])link.textContent=match[2];
  }
  function init(){
    refineAppSearch();if(!/\/search$/.test(location.pathname))return;
    const main=document.body;if(!main)return;let queued=false;
    new MutationObserver(function(){if(queued)return;queued=true;requestAnimationFrame(function(){queued=false;refineAppSearch()})}).observe(main,{childList:true,subtree:true,attributes:true,attributeFilter:['value']});
    window.addEventListener('popstate',refineAppSearch);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
